import { useParams, Link } from "react-router-dom";
import { projects } from "../Helpers/projects";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Container,
  Grid,
  Paper,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";

const ProjectDetails = () => {
  const push = useNavigate();
  const { id } = useParams();
  const project = projects.find((p) => p.id == id);

  if (!project) {
    return <div>Project not found.</div>;
  }

  return (
    <Container maxWidth="md">
      <Paper
        elevation={3}
        sx={{
          marginTop: "3rem",
          padding: "10px",
          backgroundColor: "transparent",
        }}
      >
        <Box
          sx={{
            position: "relative",
            height: "55vh",
            width: "100%",
            backgroundColor: "transparent",
          }}
          className="hi"
        >
          <img
            src={project.img}
            alt={project.name}
            width="100%"
            height="100%"
          />
          <Typography
            variant="h4"
            component="h2"
            sx={{
              position: "absolute",
              bottom: "10%",
              right: "5%",
              fontWeight: "bold",
              color: "whitesmoke",
              textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
              zIndex: 1,
              fontSize: "1.7rem",
            }}
          >
            {project.name}
          </Typography>
        </Box>
        <Grid container spacing={3} sx={{ padding: "20px" }}>
          <Grid item xs={12} sm={6}>
            <Typography
              variant="h5"
              sx={{
                fontSize: "28px",
                fontWeight: "bold",
                background: "linear-gradient(45deg, #3f51b5, #9c27b0)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
                display: "inline",
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
              }}
            >
              Overview
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: "18px",
                marginTop: "20px",
                color: "whitesmoke",
              }}
            >
              {project.decription}
            </Typography>

            <Box sx={{ marginTop: "25px" }}>
              <Link to={project.demo} style={{ textDecoration: "none" }}>
                <Button
                  variant="contained"
                  color="primary"
                  target="blank"
                  sx={{
                    marginRight: "20px",
                    background: "linear-gradient(45deg, #3f51b5, #9c27b0)",
                  }}
                >
                  Demo
                </Button>
              </Link>

              <Link to={project.github} style={{ textDecoration: "none" }}>
                <Button
                  variant="contained"
                  color="primary"
                  target="blank"
                  sx={{
                    background: "linear-gradient(45deg, #3f51b5, #9c27b0)",
                  }}
                >
                  Code
                </Button>
              </Link>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box
              sx={{
                boxSizing: "border-box",
                boxShadow: "0 0 10px black",
                backgroundColor: "transparent",
                padding: "20px",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  background: "linear-gradient(45deg, #3f51b5, #9c27b0)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  color: "transparent",
                  display: "inline",
                  textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
                }}
              >
                Technologies
              </Typography>
              <List>
                {project.technologies.map((tech, index) => (
                  <div key={index}>
                    <ListItem>
                      <ListItemText
                        primary={tech}
                        sx={{ color: "whitesmoke" }}
                      />
                    </ListItem>
                    {index < project.technologies.length - 1 && <Divider />}
                  </div>
                ))}
              </List>
            </Box>
          </Grid>
        </Grid>
        <Button
          variant="contained"
          color="primary"
          onClick={() => push(-1)}
          sx={{
            marginTop: "20px",
            marginBottom: "20px",
            background: "linear-gradient(45deg, #8a94ca, #c283cd)",
            "&:hover": {
              background: "linear-gradient(45deg, #404c8e, #7a3787)",
            },
          }}
        >
          Go back
        </Button>
        {project.features && (
          <Box
            sx={{
              boxSizing: "border-box",
              boxShadow: "0 0 10px black",
              backgroundColor: "transparent",
              padding: "20px",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontSize: "28px",
                fontWeight: "bold",
                background: "linear-gradient(45deg, #3f51b5, #9c27b0)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
                display: "inline",
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
              }}
            >
              Features
            </Typography>
            <List>
              {project.features.map((feature, index) => (
                <div key={index}>
                  <ListItem>
                    <ListItemText
                      primary={feature}
                      sx={{ color: "whitesmoke" }}
                    />
                  </ListItem>
                  {index < project.features.length - 1 && <Divider />}
                </div>
              ))}
            </List>
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default ProjectDetails;
